
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "26",
    "height": "25",
    "viewBox": "0 0 26 25"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill": "#000",
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M12.992 11.723c-.066 0-.132.005-.197.015L9.334 5.292l1.722-.997-4.157-2.579-.073 5.029 1.722-.998 3.462 6.446c-.394.48-.413 1.178-.047 1.68.367.501 1.02.67 1.57.407.55-.264.85-.89.72-1.505-.13-.615-.655-1.053-1.261-1.052zm12.292 8.595l-3.286-2.469-3.286-2.468-3.286 2.468-3.287 2.47h1.764V25h9.618v-4.682h1.763zM.703 13.797c-.388 0-.703-.327-.703-.73-.002-4.975 2.555-9.572 6.705-12.056.218-.136.49-.14.711-.01.221.131.357.375.355.64-.001.264-.14.506-.363.634-3.702 2.221-6.003 6.357-6.003 10.792 0 .403-.314.73-.702.73zM13.378 0h.039c.468 0 .702.243.702.73v2.247c0 .486-.234.73-.702.73h-.039c-.468 0-.703-.244-.703-.73V.73c0-.487.235-.73.703-.73zm9.735 12.318h2.164c.468 0 .703.243.703.73v.04c0 .486-.235.73-.703.73h-2.164c-.468 0-.702-.244-.702-.73v-.04c0-.487.234-.73.702-.73zm-1.9-3.913c.093.168.247.29.427.339.06.017.121.025.183.025.123 0 .244-.034.35-.098l1.874-1.123c.336-.202.45-.648.257-.997l-.02-.035c-.194-.349-.623-.468-.96-.267l-1.873 1.124c-.336.201-.451.647-.257.996l.019.036zm-3.326-3.454l.034.02c.336.201.766.082.96-.267l1.082-1.946c.093-.168.118-.367.07-.554-.048-.187-.165-.346-.327-.443l-.033-.02c-.336-.202-.766-.082-.96.267l-1.082 1.946c-.093.167-.119.366-.07.553.047.187.165.347.326.444zM1.265 16.406c.326-.19.762-.343 1.307-.46.545-.118 1.011-.176 1.398-.176 2.016 0 3.024 1.05 3.024 3.148v4.52H4.993v-1.09h-.026c-.491.849-1.21 1.273-2.157 1.273-.682 0-1.229-.202-1.64-.606-.41-.404-.615-.953-.615-1.648 0-1.435.823-2.27 2.47-2.504l1.98-.278c0-.87-.436-1.306-1.309-1.306-.86 0-1.67.27-2.43.812v-1.685zm2.379 3.641c-.76.104-1.14.46-1.14 1.07 0 .28.092.505.277.676.184.172.433.258.746.258.43 0 .785-.158 1.062-.474.277-.316.416-.708.417-1.177v-.535l-1.362.182zm8.854-1.48h-1.432V17.08H8.894v1.488H7.462v2.255h1.432v1.487h2.172v-1.487h1.432v-2.255z",
                        "transform": "translate(-391 -858) translate(355 841) translate(36 17)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  